import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import { MenuItem } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import _ from 'lodash';
import SelectBoxWithoutBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import { dispatchProviderList } from '../Store/actions';

function PRDetailsForm(props) {
  const dispatch = useDispatch();
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer?.CommentListData;
  });
  const getProviderList = useSelector(
    (state) => state.sharedState.ProviderReviewReducer?.getProviderList
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  React.useEffect(() => {
    if (props.linkTableName === 'PROVIDER_REVIEW' && props.showComments) {
      const tempObj =
        getProviderList &&
        getProviderList?.map((item) => {
          if (
            item.corrLinkId === props.corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === props.corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });
      dispatch(dispatchProviderList(tempObj));
    }
  }, [commentsList]);
  return (
    <div className='tab-container' bodyground='white'>
      <Spinner load={spinnerLoader} />
      <div
        className='mui-custom-form no-margin custom-check'
        data-testid='pr-detail-form'
      >
        {!props.fullScreenView ? (
          <div className='mt-2'>
            <fieldset
              data-testid='radio-box-component'
              className='custom-fieldset'
            >
              <legend className='d-none'>legend</legend>
              <div className='row'>
                <div className='col-sm-6 col-md-4'>
                  <SelectBoxWithoutBoxComponent
                    data-testid='letter-id-select-box'
                    className='mt-2'
                    labelName='Provider ID Type'
                    disabled
                    // select={false}
                    defaultValue={props.providerIdTypeDesc || ''}
                  />
                </div>
                <div className='col-sm-6 col-md-4'>
                  <SelectBoxWithoutBoxComponent
                    data-testid='name-input-box'
                    className='mt-2'
                    labelName='Provider ID'
                    required={false}
                    disabled
                    select={false}
                    defaultValue={props.formData?.providerId || ''}
                  />
                </div>
                <div className='col-sm-6 col-md-4 with-select pt-3'>
                  <TextField
                    data-testid='review_type'
                    id='review_type'
                    label='Review Type'
                    fullWidth
                    select
                    placeholder=''
                    inputProps={{ maxLength: 11, id: 'review_type' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={props.formValue?.reviewTypeCd}
                    onChange={(e) => {
                      props.handleOnChangeEvent(e.target.value, 'reviewTypeCd');
                    }}
                    disabled={!props.isEnablebyRole}
                  >
                    {props.providerDropDown &&
                    props.providerDropDown.length &&
                    props.providerDropDown.length > 0
                      ? props.providerDropDown.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        ))
                      : null}
                  </TextField>
                </div>
                <div className='col-sm-6 col-md-4'>
                  <SelectBoxWithoutBoxComponent
                    data-testid='NABP-Number'
                    className='mt-2'
                    labelName='NABP Number'
                    required={false}
                    disabled
                    select={false}
                    defaultValue={props.formData?.nabpNum || ''}
                  />
                </div>
                <div className='col-sm-6 col-md-4'>
                  <FormControlLabel
                    className='ml-0 frr-mt-42'
                    data-testid='review-frozen'
                    control={<Checkbox color='primary' className='mr-2' />}
                    label='Review Frozen'
                    value={props.formValue?.frozenindex}
                    checked={props.formValue?.frozenindex}
                    disabled={
                      props.formValue?.completeIndex || !props.isEnablebyRole
                    }
                    onChange={(e) =>
                      props.handleOnChangeEvent(e.target.checked, 'frozenindex')
                    }
                  />
                </div>
                <div className='col-sm-6 col-md-4'>
                  <FormControlLabel
                    className='ml-0 frr-mt-42'
                    data-testid='review-complete'
                    control={
                      <Checkbox
                        color='primary'
                        className='mr-2'
                        disabled={!props.isEnablebyRole}
                      />
                    }
                    label='Complete'
                    value={props.formValue?.completeIndex}
                    checked={props.formValue?.completeIndex}
                    disabled={
                      !props.formValue?.frozenindex || !props.isEnablebyRole
                    }
                    onChange={(e) =>
                      props.handleOnChangeEvent(
                        e.target.checked,
                        'completeIndex'
                      )
                    }
                  />
                </div>
                <div className='col-sm-6 col-md-4'>
                  <SelectBoxWithoutBoxComponent
                    data-testid='mfg-id-input-box'
                    className='mt-2'
                    labelName='Provider Name'
                    required={false}
                    disabled
                    select={false}
                    defaultValue={props.formData?.name || ''}
                  />
                </div>
                <div className='col-sm-6 col-md-4'>
                  <SelectBoxWithoutBoxComponent
                    data-testid='mfg-id-input-box'
                    className='mt-2'
                    labelName='Number of Claims Selected'
                    required={false}
                    disabled
                    select={false}
                    defaultValue={props.formData?.ccClaimCount || ''}
                  />
                </div>

                <div className='comment-sec pl-3 frr-mt-42'>
                  {parseInt(props?.formData?.ccCommentsExist, [0, 1]) === 1 ? (
                    <img
                      aria-label='comment'
                      data-testid='comment'
                      onClick={() => {
                        props.setCorrLinkId(props.formData?.corrLinkId);
                        props.setLinkTableName('PROVIDER_REVIEW');
                        props.setTableName('');
                        props.setShowComments(true);
                      }}
                      tabIndex={'0'}
                      onKeyDown={(e) => {
                        // Handle Enter and Space key events
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault(); // Prevents the default space scrolling behavior
                          props.setCorrLinkId(props.formData?.corrLinkId);
                          props.setLinkTableName('PROVIDER_REVIEW');
                          props.setTableName('');
                          props.setShowComments(true);
                        }
                      }}
                      src={CommentVisibleIcon}
                    />
                  ) : (
                    <img
                      aria-label='comment'
                      data-testid='comment-img'
                      onClick={() => {
                        props.setCorrLinkId(props.formData?.corrLinkId);
                        props.setLinkTableName('PROVIDER_REVIEW');
                        props.setTableName('');
                        props.setShowComments(true);
                      }}
                      tabIndex={'0'}
                      onKeyDown={(e) => {
                        // Handle Enter and Space key events
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault(); // Prevents the default space scrolling behavior
                          props.setCorrLinkId(props.formData?.corrLinkId);
                          props.setLinkTableName('PROVIDER_REVIEW');
                          props.setTableName('');
                          props.setShowComments(true);
                        }
                      }}
                      src={CommentIcon}
                    />
                  )}{' '}
                  Comments
                </div>

                {props.showComments ? (
                  <CommentAndCorrespondenceComponent
                    setShowComments={props.setShowComments}
                    linkTableName={props.linkTableName}
                    corrLinkId={props.corrLinkId}
                  />
                ) : null}
              </div>
            </fieldset>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}

export default PRDetailsForm;
